/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-05-11 15:47:54
 * description  : 描述
 * author       : zhizhan
 */
import YxUpload from "./YxUpload";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import PropTypes from "prop-types";
import { defaulProps } from "./param";

const IuploadRules = {
  rule: PropTypes.func,
  message: PropTypes.func,
};
export const IUploadConifgPropType = {
  //上传规则
  uploadRules: PropTypes.arrayOf(PropTypes.shape(IuploadRules)),

  //删除点击ok回调
  onRemoveOk: PropTypes.func,

  //删除点击取消回调
  onRemoveCancel: PropTypes.func,

  //展示类型 :thumb-缩略图text-文本,imgs-照片墙
  showType: PropTypes.oneOf(["thumb", "text", "imgs", "video"]),

  //当文件操作完成后回调，成功、失败、错误都会调用
  actionCallback: PropTypes.func,

  //文件个数限制 0为不限制， 默认0
  limit: PropTypes.number,

  //文件大小限制
  fileSize: PropTypes.number,

  // 文件类型:file-文件,img-图片
  type: PropTypes.oneOf(["file", "img", "video"]),

  //是否只读，意味着无法后期上传
  isRead: PropTypes.bool,

  //是否多选
  isMultiple: PropTypes.bool,

  //组件弹出提示，对应键传入函数即可接管
  message: PropTypes.object,

  //获得 oss 签名的url，找后端要
  url: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  //签名认证接口的token，上传认证
  AccessToken: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  //
  policyUrl: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  //请求上传接口时所带的参数
  formParams: PropTypes.object,

  //图片支持排序，拖拽
  soft: PropTypes.bool,

  //凭证处理函数
  ossFactory: PropTypes.func,

  //自定义的删除预览
  delPreview: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  //自定义的预览
  uploadPreview: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  //点击上传文件后的预览模式,mg/video/office/link 图片/视频/office文件/超链打开
  previewType: PropTypes.string,

  //上传到oss的二级文件夹名
  folder: PropTypes.string,

  // 是否混淆上传文件的名字
  isFileNameConfusion: PropTypes.bool,

  //上传按钮的配置 当type为text或者thumb起效
  uploadBtnParam: PropTypes.object,

  //文件数据，格式为[url,url...url]
  list: PropTypes.array,

  //请求头
  headers: PropTypes.object,

  //表示change触发和表单取值时将返回对象数组
  full: PropTypes.bool,

  //上转类型
  uploadType: PropTypes.oneOf(["minio", "oss", "jd", "aws", "huawei"]),

  //上转后回调
  uploadCallback: PropTypes.func,

  //上传组件加载完毕后的回调
  refLoad: PropTypes.func,

  //生命钩子，返回obj{urlList:[],paramList:[]} 包含图片上传后路径与所有配置参数
  beforeUpload: PropTypes.func,

  //额外的上传参数
  extraUploadParam: PropTypes.object,

  //展示是否显示文件名
  showFilename: PropTypes.bool,
};
YxUpload.propTypes = {
  ...IYxInputPropTypes,
  ...IUploadConifgPropType,
};
YxUpload.defaultProps = defaulProps();

export default YxUpload;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/index.js